/***
 * PC_IFG_01
 * importing the getEmployeeFeedbacks, getDomain api functions
 */
import { useState, useEffect } from "react";
import React from "react";
import { getFeedbackDataSpecificFlag, getFlagCountAndName, getReportingEmpId } from "../service/DirectorAPI";
import AddFeedback from "./AddFeedbackForm";
import moment from "moment";
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import Loader from '../StaticComponent/Loader';
import { encryptStorage } from '../constant'
import { useNavigate } from "react-router-dom";

/**
 * 
 * PC_IFG_03 create a IndivigualFlagFeedbackGrid it will return the HTML
 */
export function IndivigualFlagFeedbackGrid() {

    /***
    * PC_IFG_02
    * declaring the state variables
    */

    let login_id = encryptStorage.getItem("employeeId");
    let CurrentEvaluationId = encryptStorage.getItem("CurrentEvaluationId");
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let emp_id = params.get("EmpId");
    let flag = params.get("Flag");
    let emp_name = params.get("emp_name");
    let emp_domain = params.get("emp_domain");
    let empStatus = params.get("Status");

    let FeedbackGridarray = [];
    const [feedbackGridData, setFeedbackGridData] = useState(FeedbackGridarray);
    const [searchValue, setSearchValue] = useState("");
    const [columnOrder, setColumnOrder] = useState("DESC");
    const [columnName, setColumnName] = useState("feedbacks.modified_at");
    const [sorthide, setsorthide] = useState("");
    const [empId, setEmpId] = useState();
    const [dataLength, setdataLength] = useState(0);
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);
    const [countPerPage, setCoutPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(true);
    const [hideFeedbackForm, setHideFeedbackForm] = useState(true);
    const [reportingEmpIds, setReportingEmpIds] = useState([]);

    let filter = {
        flags: flag,
        empResponse: "Agreed",
        startDate: "",
        endDate: ""
    };
    let [filterData, setFilterData] = useState(filter);



    let IndivFlagCounts = {
        green_flag: "",
        red_flag: "",
        yellow_flag: "",
        emp_name: "",
        domain: "",
        profile_img_url: ""
    };
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);
    let breadCrumbsData = [

        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Team Member', isActive: true, path: '' },
        { title: 'Team Directory', isActive: true, path: '/TeamDirectory' },
        { title: emp_name, isActive: true, path: '' },
        { title: 'Feedbacks', isActive: false, path: '' }
    ];


    /***
     * PC_IFG_03
     * UseEffect call the loadGridPage() and loadFlagCountPage() function
     */
    let validReportTo = false;
    const navigate = useNavigate();

    useEffect(() => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let emp_id = params.get("EmpId");
        setEmpId(emp_id);
        filterData.flags = flag
        loadGridPage();
        loadFlagCountPage();
        LoadReportingEmpIds();
    }, [countPerPage, columnName, columnOrder]);

    /**
     * PC_IFG_03.1 loadGridPage function retrive the data from database
     */

    const loadGridPage = async (filter = {}) => {

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let emp_id = params.get("EmpId");
        setEmpId(emp_id);
        setIsLoading(false);

        if (filter?.flags === undefined) {
            filter = filterData
        }

        try {
            let empdata = {
                evaluation_id: CurrentEvaluationId,
                emp_id: emp_id,
                searchData: searchValue,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: countPerPage,
                flags: filter.flags,
                emp_response: filterData.empResponse,
                startDate: filter.startDate,
                endDate: filter.endDate


            };
             switch (encryptStorage.getItem('groupid')) {
                case '1':
                    {
                        validReportTo = true;
                        break;
                    }
                case '2':
                    {
                        if (encryptStorage.getItem('employeeId') == emp_id) {
                            validReportTo = true;

                        }
                        else {

                            let request = {
                                login_id: encryptStorage.getItem('employeeId'),
                            };
                            let respdata = await getReportingEmpId(request);

                            for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                                if (respdata.data.ResponseData[0][i]?.emp_id === emp_id) {
                                    validReportTo = true;
                                }
                                //
                            }
                        }
                        break;
                    }
                // case '3':
                //     {
                //         if (responsedata?.data?.ResponseData[0]?.emp_id == encryptStorage.getItem('employeeId'))
                //             validReportTo = true;
                //         break
                //     }
                default:
                    {
                        navigate('*')
                        break;
                    }

            }
            if (validReportTo) {
                let data = await getFeedbackDataSpecificFlag(empdata);

                setFeedbackGridData(data.data.ResponseData[0]);
                setdataLength(data.data.ResponseData[1]);
                if (data.data.status == 200) {
                    setIsLoading(true);
                }
            } else {
                navigate('/', { state: { hideNav: false } });
            }

        } catch (e) {

        }
    };

    /**
     * PC_IFG_03.2 loadFlagCountPage function get the data from database
     */
    const loadFlagCountPage = async () => {
        try {

            let empdata = {

                evaluation_id: CurrentEvaluationId,
                emp_id: emp_id,  //to_emp_id
                login_emp_id: login_id //emp_id
            };

            let data = await getFlagCountAndName(empdata);


            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {


                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    domain: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url
                };


                setIndivFlagCountsData(IndivFlagCounts);
            }

        } catch (e) {

        }
    };

    const LoadReportingEmpIds = async () => {
        let loginEmpData = { login_id: login_id };
        let responsedata = await getReportingEmpId(loginEmpData);
        if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {
            setReportingEmpIds(responsedata.data.ResponseData[0]);
        }
    };

    /**
     * 
     * @returns PC_IFG_10 this function bind the value into the grid
     */
    const feedbackGridBodyData = () => {
        try {

            if (feedbackGridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img src="/Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty" style={{ height: '500px', width: '750px' }} />
                                <h2 className="tt-bold font-15 text-center margin-negative">No Feedbacks Found</h2>
                            </div>
                        </td>
                    </tr>
                )
            }
            else {



                return feedbackGridData.map((obj, index) => {
                    let m = moment(new Date(obj.modified_at));
                    let FeeabackDate = m.format("MMM DD, YYYY");

                    var tipCount;
                    var commentsBind;
                    if (obj.comments.length > 15) {
                        commentsBind = obj.comments.substring(0, 15)
                        commentsBind = commentsBind + '...'
                        tipCount = 1;
                    }
                    else {
                        commentsBind = obj.comments
                        tipCount = 0;
                    }

                    var CommentstipCount;
                    var commentsBasedOn;
                    if (obj.comments_based_on.length > 40) {
                        commentsBasedOn = obj.comments_based_on.substring(0, 40)
                        commentsBasedOn = commentsBasedOn + '...'
                        CommentstipCount = 1;
                    }
                    else {
                        commentsBasedOn = obj.comments_based_on
                        CommentstipCount = 0;
                    }

                    return (
                        <tr className="hive-table-data">

                            <td>{FeeabackDate}</td>

                            {obj.flags == "G" ? (<td className="text-center"><img src="/Images/profile-feedback-green.svg" className="profile-feedback-flag-size" alt="Flag Icon Green" /></td>) : null}
                            {obj.flags == "Y" ? (<td className="text-center"><img src="/Images/profile-feedback-yellow.svg" className="profile-feedback-flag-size" alt="Flag Icon Yellow" /></td>) : null}
                            {obj.flags == "R" ? (<td className="text-center"><img src="/Images/profile-feedback-red.svg" className="profile-feedback-flag-size" alt="Flag Icon Red" /></td>) : null}
                            {obj.flags == null || obj.flags == undefined ? (<td className="text-center"><span>-</span></td>) : null}

                            <td>{obj.feedbacked_by}</td>
                            {/* <td>{obj.comments_based_on}</td> */}
                            {/* <td> {obj.comments} </td> */}
                            <td><a className={CommentstipCount == 0 ? "tooltip-color tooltipCursor" : "tooltip-color"} data-bs-toggle="tooltip" data-bs-placement="top" title={CommentstipCount == 1 ? obj.comments_based_on : ''}>{commentsBasedOn}</a></td>
                            <td><a className={tipCount == 0 ? "tooltip-color tooltipCursor" : "tooltip-color"} data-bs-toggle="tooltip" data-bs-placement="top" title={tipCount == 1 ? obj.comments : ''}>{commentsBind}</a></td>
                            {obj.emp_response == "Pending" || obj.emp_response == "pending" ? (<td className="text-center"><span className="status-btn bg-pastel-orange">{obj.emp_response}</span></td>) : null}
                            {obj.emp_response == "Agreed" ? (<td className="text-center"><span className="status-btn bg-pastel-green">{obj.emp_response}</span></td>) : null}
                            {obj.emp_response == "Disagree" ? (<td className="text-center"><span className="status-btn bg-pastel-red">{obj.emp_response}</span></td>) : null}
                            <td className="text-center"><a href={`/Feedback?EmpId=${obj.emp_id}&FeedbackId=${obj.id}&EvaluationId=${obj.evaluation_id}&Flag=${flag}&isIndivigualfeedbackgrid=true&&Status=${empStatus}`} className="text-decoration-none">View</a ></td>
                        </tr>

                    );
                });
            }
        } catch (e) {

        }
    };

    /**
     * 
     * PC_IFG_13 this function set the column name and column order
     */

    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split("@");

            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
        } catch (error) { }
    };

    /**
     * 
     * PC_IFG_22 tis function setstate the values into the variables
     */
    const OnChangeName = (e) => {
        setFilterData({ ...filterData, [e.target.name]: e.target.value });
    };

    /**
     * PC_IFG_23 this function set the value to hideFilterpopup variable 
     * to hide and show the filter popup
     */
    const filterClicked = async () => {

        try {

            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (e) {

        }

    }
    /**
     * PC_IFG_23 this function clear the filter field values
     */
    const filterClearClicked = () => {

        let filter = {
            flags: flag,
            empResponse: "",
            startDate: "",
            endDate: ""
        };
        filterClicked();
        setFilterData(filter);
        loadGridPage(filter);

    }

    /**
     * PC_IFG_13 this function increment the countPerPage value
     */
    const handleLoadMore = () => {
        try {
            setCoutPerPage(countPerPage + 10);
        } catch (e) {

        }
    }

    const addFeedbackClicked = () => {
        setHideFeedbackForm(false);
    }



    return (

        <div className="container-fluid mt-5">
            <Loader isLoading={isLoading} />
            <div className="row justify-content-center body-bg" >
                {/*Tab Structure Starts Here*/}
                <div className="col-md-11" style={{ marginTop: "10px" }}>
                    <BreadCrumbs data={breadCrumbsData} />
                </div>
                <div className="col-md-11 d-flex justify-content-between my-4  align-items-center">
                    <label className="tt-bold font-15 ">{emp_name}({emp_domain}) - Feedback</label>

                    <div className="d-flex">

                        <div className="bg-white me-2">
                            <div className="text-center m-2">
                                <span className="me-3"><img src="/Images/Green-Flag.svg" alt="green-flag" data-bs-toggle="tooltip" data-bs-placement="bottom" title data-bs-original-title="green flag " aria-label="green flag " />
                                    <span className="ms-2">{indivFlagCountsData.green_flag ? indivFlagCountsData.green_flag : 0}</span></span>
                                <span className="me-3"><img src="/Images/Yellow-Flag.svg" alt="yellow-flag" data-bs-toggle="tooltip" data-bs-placement="bottom" title data-bs-original-title="yellow flag " aria-label="yellow flag " />
                                    <span className="ms-2">{indivFlagCountsData.yellow_flag ? indivFlagCountsData.yellow_flag : 0}</span></span>
                                <span><img src="/Images/red-flag.svg" alt="red-flag" data-bs-toggle="tooltip" data-bs-placement="bottom" title data-bs-original-title="red flag " aria-label="red flag " />
                                    <span className="ms-2">{indivFlagCountsData.red_flag ? indivFlagCountsData.red_flag : 0}</span></span>
                            </div>
                        </div>


                        <div className="ms-auto d-flex">
                            {/*Filter Section Starts Here*/}
                            <div className="dropdown">
                                <button className="advanced-filter-button me2 medium-text" type="button" id="feedback-filter-dropdown" data-bs-toggle="dropdown" onClick={() => filterClicked()}>
                                    <img src="/Images/filter-icon.svg" className="me-2" />Filter
                                </button>
                                {!hideFilterPopUp ? <div className="dropdown-menu px-3 advanced-filter-panel feedback-grid-filter" style={{ display: "block" }}>
                                    <div className="row">
                                        <div className="col-md-12 py-2 border-0 mb-1"><span className="font-14 semibold-text advanced-filter-title">Advanced Filter</span>
                                            <button type="button" className="btn-close float-end close-filter" data-bs-dismiss="advanced-filter" aria-label="Close" onClick={() => filterClicked()} />
                                        </div>
                                        <div className="col-md-12 ">
                                            {/* <div className="row mb-3">

                                                <div className="col-md-6 mb-3 ">
                                                    <label className="form-label hive-form-label" htmlFor="approval-status">Status</label>
                                                    <select className="form-select hive-form-control" id="approval-status"
                                                        name="empResponse" value={filterData.empResponse} onChange={(e) => { OnChangeName(e); }}>
                                                        <option value="">Select</option>
                                                        <option >Agreed</option>
                                                        <option >Disagree</option>
                                                        <option >Pending</option>
                                                    </select>
                                                </div>

                                            </div> */}
                                            <div className="col-md-12 pb-2 border-0 ">
                                                <span className="font-14 semibold-text filter-title">Date Range</span>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="fromrange">From</label>
                                                    <input type="date" className="form-control hive-form-control" id="fromrange"
                                                        name="startDate" value={filterData.startDate} max={filterData.endDate} onChange={(e) => { OnChangeName(e); }} />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="torange">To</label>
                                                    <input type="date" className="form-control hive-form-control" id="torange"
                                                        name="endDate" value={filterData.endDate} min={filterData.startDate} onChange={(e) => { OnChangeName(e); }} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 my-3 d-flex justify-content-end">
                                            <button className="btn hive-btn-secondary"
                                                onClick={() => filterClearClicked()}>Clear</button>
                                            <button className="btn hive-btn-primary" onClick={() => loadGridPage()} >Apply</button>
                                        </div>
                                    </div>
                                </div> : null}
                            </div>
                            {/*Filter Section Ends Here*/}
                            {empStatus != "Inactive" && reportingEmpIds.some(emp => emp.emp_id == emp_id) ? <button className="btn hive-btn-primary ms-3" data-bs-toggle="modal" data-bs-target="#AddFeedbackDetailsPopup" onClick={() => addFeedbackClicked()}><img className="me-2" src="/Images/profile-plus-action.svg" alt="Plus Icon" />Add Feedback</button> : null}
                        </div>
                    </div>
                </div>
                {/*Tab Content Starts Here*/}



                <div className="col-md-11">
                    <div className="table-responsive">
                        <table className="table bg-white hive-grid table-borderless profile-regular-font">
                            <thead>
                                <tr>


                                    <th className="hive-table-head bold-text font-14">Date<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedbacks.modified_at@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.modified_at@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedbacks.modified_at@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.modified_at@ASC" ? false : true} />
                                    </span>
                                    </th>
                                    <th className="hive-table-head text-center bold-text font-14">Flags</th>
                                    <th className="hive-table-head bold-text font-14">Feedbacks By<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feed_by.emp_name@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feed_by.emp_name@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feed_by.emp_name@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feed_by.emp_name@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head bold-text font-14">Feedbacks<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedback_data.comments_based_on@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedback_data.comments_based_on@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedback_data.comments_based_on@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedback_data.comments_based_on@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head bold-text font-14">Comments</th>
                                    <th className="hive-table-head text-center bold-text font-14">Response<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedbacks.emp_response@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.emp_response@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedbacks.emp_response@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.emp_response@ASC" ? false : true} />
                                    </span>
                                    </th>
                                    <th className="hive-table-head text-center bold-text font-14">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedbackGridBodyData()}



                            </tbody>
                        </table>
                    </div>
                    <div className="text-center">
                        {dataLength > countPerPage ? <button className="btn bg-white font-14 medium-text mb-3" onClick={() => handleLoadMore()}>Show More</button> : null}
                    </div>
                </div>

                {/*All Leave Request Section Ends Here*/}
                {/*My Leave Request Section Starts Here*/}
                <div className="tab-pane fade show active" id="my_leave_request" role="tabpanel" aria-labelledby="my_leave_request_tab">
                </div>
                {/*My Leave Request Section Ends Here*/}
                {/*WFH Request Section Starts Here*/}
                <div className="tab-pane fade show active" id="wfh_request" role="tabpanel" aria-labelledby="wfh_request_tab">
                </div>
                {/*WFH Request Section Ends Here*/}
                {/*My WFH Request Section Starts Here*/}
                <div className="tab-pane fade show active" id="my_wfh_request" role="tabpanel" aria-labelledby="my_wfh_request_tab">
                </div>
                {/*My WFH Request Section Ends Here*/}

                {/* PC_IFG_12 AddFeedback is called from AddFeebbackForm.jsx */}
                <AddFeedback empId={empId} empName={emp_name} empDomain={emp_domain} ReloadGridPage={() => loadGridPage()} hideFeedbackForm={hideFeedbackForm} setHideFeedbackForm={() => setHideFeedbackForm()} />
            </div>
        </div>




    );

}

export default IndivigualFlagFeedbackGrid;